import { createContext, useContext } from 'react';

import { CommunityContract } from 'types/contracts';
import { FeeDataType } from 'types/fees';

import { CareDataType } from './types';

type CareTypesContentType = {
  careType: CareDataType | undefined;
  contract: CommunityContract | undefined;
  fees: FeeDataType | undefined;
  setContract: (contract: CommunityContract) => void;
  setFees: (data: FeeDataType) => void;
};

export const CareTypesContext = createContext<CareTypesContentType>({
  careType: undefined,
  contract: undefined,
  fees: undefined,
  setContract: () => {
    // Do nothing
  },
  setFees: () => {
    // Do nothing
  },
});

export const useCareTypesContext = () => useContext(CareTypesContext);
